import React, { useState } from 'react';
import cx from 'classnames';
import { Divider, ListItemIcon, Menu } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { useImpersonatedUser } from 'new/hooks/adapters/useImpersonatedUser';
import { IconMenuItem, NestedMenuItem } from 'mui-nested-menu';
import structure from 'new/routes/structure';
import { useCurrentUser } from 'new/hooks/adapters/useCurrentUser';
/**
 * SVG Icon imports
 */
import { ReactComponent as NexlaIcon } from './icons/nexla-icon.svg';
import { ReactComponent as ChevronDown } from 'new/components/icons/ArrowDropDownFilled.svg';

import s from './NexlaContextualMenu.module.scss';

const renderChevron = (anchor: HTMLElement) => (
  <ChevronDown style={{ transform: `rotate(${anchor ? 180 : 0}deg)` }} />
);

const ContextualMenu = () => {
  const history = useHistory();
  const user = useCurrentUser();
  const impersonated = useImpersonatedUser();
  const [anchor, setMenuAnchor] = useState(null);

  const onClickMenu = (e: { currentTarget: any }) => setMenuAnchor(e.currentTarget);

  const onCloseMenu = () => setMenuAnchor(null);

  const onClickItem = (to: string) => () => history.push(to);

  return (
    <>
      <button onClick={onClickMenu} className={cx(s.buttonMenu, anchor && s.buttonMenuOpen)}>
        <NexlaIcon />
        {renderChevron(anchor)}
      </button>

      <Menu
        anchorEl={anchor}
        open={!!anchor}
        onClose={onCloseMenu}
        style={{ marginTop: 'var(--spacing-sm)' }}
      >
        <div aria-label="inner-menu-container">
          {structure.map((item) => {
            if (!item.groups || !item.groups(user, impersonated).length) {
              return (
                <IconMenuItem
                  key={item.name}
                  className={s.menuItemContainer}
                  onClick={onClickItem(item?.to)}
                  leftIcon={<ListItemIcon>{item?.Icon}</ListItemIcon>}
                  label={item?.name}
                />
              );
            } else {
              return (
                <NestedMenuItem
                  key={item.name}
                  className={s.menuItemContainer}
                  onClick={onClickItem(item.to)}
                  leftIcon={<ListItemIcon key={`icon_${item.name}`}>{item?.Icon}</ListItemIcon>}
                  label={item.name}
                  parentMenuOpen={!!anchor}
                >
                  {item.groups
                    ? item.groups(user, impersonated).map((group, ix) => {
                        if (!group) return null;
                        if (!group.items) return null;

                        const key = `${group?.name}_${ix}`;

                        return (
                          <React.Fragment key={group.name}>
                            {ix !== 0 ? <Divider /> : null}
                            {group.items
                              .filter((i) => !!i)
                              .map((item, idx) => {
                                const itemKey = typeof item.title === 'string' ? item.title : idx;

                                return (
                                  <IconMenuItem
                                    key={itemKey}
                                    label={item?.title as string}
                                    className={s.menuItemContainer}
                                    onClick={onClickItem(item?.to)}
                                    leftIcon={<ListItemIcon>{item?.Icon}</ListItemIcon>}
                                  />
                                );
                              })}
                          </React.Fragment>
                        );
                      })
                    : null}
                </NestedMenuItem>
              );
            }
          })}
        </div>
      </Menu>
    </>
  );
};

export const NexlaContextualMenu = React.memo(ContextualMenu);
